export var FlowAction;
(function (FlowAction) {
    FlowAction["Save"] = "freeflow.edit";
    FlowAction["Submit"] = "freeflow.submit";
    FlowAction["Comment"] = "freeflow.comment";
    FlowAction["Preview"] = "freeflow.preview";
    FlowAction["Withdraw"] = "freeflow.withdraw";
    FlowAction["Agree"] = "freeflow.agree";
    FlowAction["Reject"] = "freeflow.reject";
    FlowAction["Pay"] = "freeflow.pay";
    FlowAction["Print"] = "freeflow.print";
    FlowAction["PrintInvoice"] = "freeflow.printInvoice";
    FlowAction["PrintDoc"] = "freeflow.printDoc";
    FlowAction["Printed"] = "freeflow.printed";
    FlowAction["PrintRemind"] = "freeflow.remind";
    FlowAction["StartSignature"] = "freeflow.start.signature";
    FlowAction["ViewSignature"] = "freeflow.view.signature";
    FlowAction["Activate"] = "freeflow.activate";
    FlowAction["Send"] = "freeflow.send";
    FlowAction["SkipSend"] = "freeflow.skip.send";
    FlowAction["Receive"] = "freeflow.receive";
    FlowAction["ReceiveException"] = "freeflow.receiveExcep";
    FlowAction["CancelReceiveException"] = "freeflow.cancelReceiveExcep";
    FlowAction["Nullify"] = "freeflow.nullify";
    FlowAction["Modify"] = "freeflow.editApproving";
    FlowAction["ShiftNode"] = "freeflow.shiftnode";
    FlowAction["AddNode"] = "freeflow.addnode";
    FlowAction["AddSignNode"] = "freeflow.addSignNode";
    FlowAction["AdminShiftNode"] = "freeflow.adminShiftnode";
    FlowAction["Suspend"] = "freeflow.suspend";
    FlowAction["Back"] = "freeflow.back";
    FlowAction["AddExpress"] = "freeflow.addExpress";
    FlowAction["JumpExpress"] = "freeflow.jumpExpress";
    FlowAction["ShiftApprove"] = "freeflow.shiftApprove";
    FlowAction["Urge"] = "freeflow.urge";
    FlowAction["MarkedRead"] = "freeflow.read";
    FlowAction["AdminSkipNode"] = "freeflow.admin.skipnode";
    FlowAction["Alter"] = "freeflow.alter";
    FlowAction["Copy"] = "freeflow.copy";
    FlowAction["Retract"] = "freeflow.retract";
    FlowAction["Cancel"] = "freeflow.cancel";
    FlowAction["Delete"] = "freeflow.delete";
    FlowAction["ExportAttachment"] = "freeflow.export";
    FlowAction["Share"] = "freeflow.share";
    FlowAction["AdminBack"] = "freeflow.admin.back";
    FlowAction["AdminAddNode"] = "freeflow.admin.addnode";
    FlowAction["RemindAddingInvoice"] = "INVOICE_REMIND";
})(FlowAction || (FlowAction = {}));
